/*!
 * Copyright © 2022. Verizon Connect Ireland Limited. All rights reserved.
 */

import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { ILocalStorageService } from './local-storage.service.interface';

@Injectable({
  providedIn: 'root'
})
export class LocalStorageService implements ILocalStorageService {
  constructor(@Inject(DOCUMENT) private readonly _document: Document) {}

  public getItem(key: string) {
    return this._document.defaultView.localStorage.getItem(key);
  }

  public setItem(key: string, value: string) {
    this._document.defaultView.localStorage.setItem(key, value);
  }
}
